import React from 'react';
import { Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import moment from 'moment';
import styled from 'styled-components';

const { Text } = Typography;

const LocationContainer = styled.div`
	display: flex;
	align-items: flex-start;
`;

export const LocationIconWrapper = styled.div`
	background-color: #e6f7ff;
	border-radius: 20%;
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 12px;
	flex-shrink: 0;
`;

const LocationTextSecondary = styled(Text)`
	&& {
		font-size: 12px;
	}
`;

const StatusBadge = styled.span`
	color: #262626;
	background-color: #f5f5f5;
	padding: 4px 8px;
	border-radius: 4px;
	font-size: 12px;
	font-weight: bold;
`;

export const TripNodesTableConfig = (normalizeNodeStatus, isTripClosed) => [
	{ title: 'Node', dataIndex: 'node_type', key: 'node', width: '90px' },
	{
		title: 'Location',
		key: 'location',
		width: '250px',
		render: (_, record) => (
			<LocationContainer>
				<LocationIconWrapper>
					<EnvironmentOutlined style={{ color: '#1890ff', fontSize: '14px' }} />
				</LocationIconWrapper>
				<div>
					<Text strong>{record.node_name}</Text>
					<br />
					<LocationTextSecondary type="secondary">
						{record.location_address || '-'}
					</LocationTextSecondary>
				</div>
			</LocationContainer>
		),
	},
	{
		title: 'Last Updated',
		key: 'lastUpdated',
		width: '100px',
		render: (_, record) => (
			<Text>
				{record.last_updated
					? moment(record.last_updated)
							.add(5, 'hours')
							.add(30, 'minutes')
							.format('hh:mm A')
					: '-'}
			</Text>
		),
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
		width: '100px',
		render: (status) => (
			<StatusBadge>{normalizeNodeStatus(status, isTripClosed) || status}</StatusBadge>
		),
	},
];
